(() => {
  const updateClock = () => {
    const clock = document.querySelector('[data-fb-clock]');
    if (!clock) return;
    const now = new Date();
    const time = new Intl.DateTimeFormat(undefined, { hour: 'numeric', minute: '2-digit' }).format(now);
    const date = new Intl.DateTimeFormat(undefined, { month: 'short', day: 'numeric', year: 'numeric' }).format(now);
    clock.innerHTML = `<span>${time}</span><span class="fb-task-date">&nbsp; ${date}</span>`;
  };

  const setTaskTitle = () => {
    const title = document.querySelector('[data-fb-task-title]');
    if (!title) return;
    const heading = document.querySelector('main h1, main .product__title h1, main .collection-hero__title');
    title.textContent = heading?.textContent?.trim() || 'FREAKshop';
  };

  /* Keep purchasable items above sold-out items on collection pages.
     Shopify's built-in sort options do not include availability, so this
     rearranges the products already returned for the current collection page. */
  const arrangeCollectionAvailability = () => {
    if (!document.body.classList.contains('template-collection')) return;
    const grid = document.querySelector('#product-grid, .product-grid');
    if (!grid) return;

    const items = Array.from(grid.children).filter((item) => item.matches('.grid__item'));
    if (!items.length) return;

    const available = [];
    const soldOut = [];

    items.forEach((item) => {
      const card = item.querySelector('[data-fb-available]');
      if (card?.dataset.fbAvailable === 'false') soldOut.push(item);
      else available.push(item);
    });

    grid.querySelectorAll('.fb-dead-files-divider').forEach((el) => el.remove());

    const desired = [...available, ...soldOut];
    const current = items;
    const needsMove = desired.some((item, index) => item !== current[index]);
    if (needsMove) desired.forEach((item) => grid.appendChild(item));

    if (soldOut.length) {
      const divider = document.createElement('li');
      divider.className = 'grid__item fb-dead-files-divider';
      divider.setAttribute('aria-label', 'Sold out items');
      divider.innerHTML = '<span>DEAD_FILES // SOLD OUT</span><small>Archived here until somebody restocks the damn things.</small>';
      grid.insertBefore(divider, soldOut[0]);
    }
  };

  let arrangeTimer;
  const scheduleArrange = () => {
    window.clearTimeout(arrangeTimer);
    arrangeTimer = window.setTimeout(arrangeCollectionAvailability, 40);
  };

  document.addEventListener('DOMContentLoaded', () => {
    updateClock();
    setTaskTitle();
    arrangeCollectionAvailability();
    window.setInterval(updateClock, 30000);

    if (document.body.classList.contains('template-collection')) {
      const observer = new MutationObserver((mutations) => {
        if (mutations.some((m) => Array.from(m.addedNodes).some((n) => n.nodeType === 1 && !n.classList?.contains('fb-dead-files-divider')))) {
          scheduleArrange();
        }
      });
      observer.observe(document.querySelector('#MainContent') || document.body, { childList: true, subtree: true });
    }
  });

  document.addEventListener('shopify:section:load', () => {
    setTaskTitle();
    arrangeCollectionAvailability();
  });
})();
